import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../material.module';
import { FormStateTreeComponent } from './form-state-tree/form-state-tree.component';

@NgModule({
  imports: [CommonModule, ReactiveFormsModule, FormsModule, MaterialModule],
  declarations: [FormStateTreeComponent],
  exports: [FormStateTreeComponent],
})
export class UtilsModule {}
